import secondaryButtonLightGrayHover from '../../../../../common/algorithms/secondary-button-light-gray-hover';

const secondary = (params) => secondaryButtonLightGrayHover(params);

export default secondary;
